// The sidebar renders each admin's own `permissions` from the database, so a new menu
// normally needs scripts/addRevenueMenu.js (backend repo) to be run. Until it has been
// run for a user, their Revenue and Payouts entries are derived from their Transactions
// entry here: anyone who can see Transactions can see them. Once a saved entry exists,
// it is used as-is.

export const REVENUE_MENU_NAME = "Revenue";
export const PAYOUTS_MENU_NAME = "Payouts";

// Only used while no saved entry exists. Chosen well clear of the real menu ids
// (200001-300002) so they can never collide with one.
const FINANCE_MENUS = [
    { menu: REVENUE_MENU_NAME, fallbackId: 290001, icon: "monitoring", offset: 0.5 },
    { menu: PAYOUTS_MENU_NAME, fallbackId: 290002, icon: "payments", offset: 0.6 },
];

const isMenu = (entry, name) => String(entry?.menu || "").trim().toLowerCase() === name.toLowerCase();

export const withRevenueMenu = (permissions) => {
    const list = Array.isArray(permissions) ? permissions : [];
    const transactions = list.find((p) => isMenu(p, "Transactions"));
    if (!transactions) return list;
    const { submenus, ...base } = transactions; // eslint-disable-line no-unused-vars
    const missing = FINANCE_MENUS
        .filter((m) => !list.some((p) => isMenu(p, m.menu)))
        .map((m) => ({
            ...base,
            menu: m.menu,
            menuid: m.fallbackId,
            icon: m.icon,
            sortOrder: Number(transactions.menuid) + m.offset,
        }));
    return missing.length > 0 ? [...list, ...missing] : list;
};

/** The id the sidebar uses for a menu, whether saved or derived above. */
export const menuIdFor = (permissions, name) =>
    withRevenueMenu(permissions).find((p) => isMenu(p, name))?.menuid;

export const revenueMenuId = (permissions) => menuIdFor(permissions, REVENUE_MENU_NAME);
